// import Phaser from 'phaser'
import Matter from 'matter-js'
import Config from '../launch/config'
import Towable from '../towable/towable'
import Effects from '../effects/effects'

export default class Artifact extends Towable {
    constructor(props) {
        props.texture = 'artifactWhite'
        props.type = 'artifact'

        super(props)

        this.fillColor = 0x8672fb
        this.isCollected = false
        this.faction = null

        this.timedEffect = Config.scene.time.addEvent({
            delay: 5000,
            callback: () => {
                const {
                    isBeingTowed,
                    isDiscovered,
                    isInOrbit,
                    isMoving,
                    sprite,
                } = this

                if (
                    sprite.body &&
                    !isBeingTowed &&
                    isDiscovered &&
                    !isInOrbit &&
                    !isMoving
                ) {
                    new Effects().ringGrowFade({
                        minRadius: 20,
                        maxRadius: 60,
                        duration: 3000,
                        x: sprite.x,
                        y: sprite.y,
                        width: 2,
                    })
                }
            },
            loop: true,
        })

        Config.artifacts[this.id] = this
    }

    destroy() {
        this.timedEffect.remove()

        super.destroy()
    }

    orbit() {
        super.orbit()

        if (this.orbitingEntity) {
            this.timedEffect.remove()
        }
    }

    update() {
        super.update()

        if (this.sprite.body && !this.isMoving) {
            Matter.Body.rotate(this.sprite.body, 0.01)
        }

        this.faction = null

        if (this.isInOrbit && this.orbitingEntity) {
            if (this.orbitingEntity.faction === Config.enemyFactionName) {
                this.fillColor = `0x${Config.colorRed}`
                this.faction = Config.enemyFactionName
                this.isCollected = false
            }

            if (this.orbitingEntity.faction === Config.userFactionName) {
                this.fillColor = `0x${Config.colorGreen}`
                this.faction = Config.userFactionName
                this.isCollected = true
            }
        }

        if (Config.isGameOver && !this.timedEffect.paused) {
            this.timedEffect.paused = true
        }

        this.sprite.setTintFill(this.isSelected ? 0xffffff : this.fillColor)
    }
}
